import HomeIcon from '@mui/icons-material/Home';
import CategoryIcon from '@mui/icons-material/Category';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import ReceiptIcon from '@mui/icons-material/Receipt';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import QrCodeIcon from '@mui/icons-material/QrCode';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';

export const drawerRoute = [
    // {
    //     id: 1,
    //     name: 'Home',
    //     path: '/',
    //     icon: <HomeIcon />
    // },
    {
        id: 2,
        name: 'Billing',
        path: '/billing',
        icon: <ReceiptIcon />
    },
    {
        id: 3,
        name: 'Supplier Management',
        path: '/SupplierManagement',
        icon: <PersonAddIcon />
    },
    {
        id: 4,
        name: 'Category Management',
        path: '/CategoryManagement',
        icon: <CategoryIcon />
    },
    {
        id: 5,
        name: 'Pet Management',
        path: '/PetManagement',
        icon: <SupportAgentIcon />
    },
    {
        id: 6,
        name: 'User Management',
        path: '/UserManagement',
        icon: <AdminPanelSettingsIcon />
    },
    {
        id: 7,
        name: 'Item Management',
        path: '/ItemManagement',
        icon: <CategoryIcon />
    },
    {
        id: 8,
        name: 'Doctor Management',
        path: '/DoctorManagement',
        icon: <LocalHospitalIcon />
    },
    {
        id: 9,
        name: 'Barcode Genaration',
        path: '/barcodeGen',
        icon: <QrCodeIcon />
    },
    {
        id: 9,
        name: 'GRN',
        path: '/grn',
        icon: <EventAvailableIcon />
    },
    {
        id: 12,
        name: 'To Main Store',
        path: '/StockReturn',
        icon: <AssignmentReturnIcon />
    },
    {
        id: 11,
        name: 'Stock Management',
        path: '/StockAllocation',
        icon: <Inventory2Icon />
    },
    {
        id: 10,
        name: 'Reports',
        path: '/ReportModule',
        icon: <TextSnippetIcon />
    },
    // {
    //     id: 10,
    //     name: 'Dashboard',
    //     path: '/SystemAnalysis',
    //     icon: <AnalyticsIcon />
    // }

]